const DashboardState = ({ svg = "", text = "", amount = "", flag = "" }) => {
  const formatNumber = (num) => {
    if (num === null) return num;
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  };
  return (
    <>
      <div className="px-4 py-2 w-80 h-32 border border-gray-200  bg-white shadow-sm  rounded-lg flex items-center space-x-4">
        <div className={`w-10 h-10 0 rounded-md p-1 text-${flag}`}>{svg}</div>

        <div className="flex flex-col items-center space-y-1">
          <h1 className="self-start text-gray-400 font-medium text-sm">
            {text}
          </h1>
          <h3 className="text-2xl text-gray-800 font-bold self-start">
            ${formatNumber(amount)}
          </h3>
        </div>
      </div>
    </>
  );
};

export default DashboardState;
